import { render, staticRenderFns } from "./ApplyForm.vue?vue&type=template&id=bc424d66"
import script from "./ApplyForm.vue?vue&type=script&lang=ts"
export * from "./ApplyForm.vue?vue&type=script&lang=ts"
import style0 from "./ApplyForm.vue?vue&type=style&index=0&id=bc424d66&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports